<template>
  <div class="w-100">
    <div v-if="is_load" class="w-100 text-center">
      <loader></loader>
    </div>
    <template v-else>
      <div class="p-4">
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
          <div class="mb-4">
            <!-- RESERVATION DETAIL -->
            <div class="mb-4" v-if="reservation.id">
              <div class="w-100 mb-4 bg-white rounded-6 border-semi-grey box-shadow-light-aff p-3">
                <p class="mb-3 body-1-4">Reservation Detail</p>
                <div class="row no-gutters">
                  <div class="col-2 align-self-center">
                    <div class="w-100 pr-2">
                      <div class="w-100 bg-orange text-center radius-8" style="padding:13px 0px;">
                        <i class="simple-icon-home text-18 text-white"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 align-self-center">
                    <div class="pr-2">
                      <p class="mb-0 body-2-1">{{reservation.room_type.name}}</p>
                      <div class="w-100 no-ws">
                        <p class="mb-0 d-inline-block align-middle body-3-3-1 mr-2">Room : </p>
                        <p class="mb-0 d-inline-block align-middle body-3-1">{{reservation.room.id ? reservation.room.name : '-'}}</p>
                      </div>
                      <p class="mb-0 body-3-1 text-info">Folio {{reservation.folio_number != '' ? `#${reservation.folio_number}` : '#'}}</p>
                    </div>
                  </div>
                  <div class="col-3 align-self-center text-right">
                    <p class="mb-0 body-3-3-1">Guest Name</p>
                    <p class="mb-0 body-3-1">{{reservation.guest_profile != null ? reservation.guest_profile.name : reservation.booked_by.name}}</p>
                  </div>
                  <div class="col-12 my-3">
                    <div class="w-100 border-2-bottom-dashed"></div>
                  </div>
                  <div class="col-6">
                    <p class="mb-0 body-3-3-1">Check in</p>
                    <p class="mb-0 body-3-1">{{$formatDate(reservation.arrival_date,'YYYY-MM-DD')}}</p>
                  </div>
                  <div class="col-6">
                    <p class="mb-0 body-3-3-1">Check out</p>
                    <p class="mb-0 body-3-1">{{$formatDate(reservation.departure_date,'YYYY-MM-DD')}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <UserPreference :question="data" @sendBackAnswer="savePreferenceAnswer" :show_back_button="false"></UserPreference>
          </div>
          <div class="py-3" v-if="error_push != ''">
            <ErrorMessage :message="error_push"></ErrorMessage>
          </div>
          <state-button :click="submitForm" variant="primary" size="lg" block>Submit</state-button>
        </template>
      </div>
    </template>


    <!-- SUCCESS -->
    <popup-detail 
      id_ref="show_message_success"
      direction="bottom" 
      :show="show_message_success"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleSuccessMessage">
      <template v-slot:body>
        <div class="py-5 px-4 text-center">
          <div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-green rounded-100 mx-auto size-icon-in">
              <img src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
            </div>
          </div>
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">Data saved successfully</p>
          <p class="mb-2 body-2-2">Thank you for filling out the preference form. Enjoy your stay</p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <router-link :to="`/${getMerchant.code}`">
            <button 
              class="ga-btn-primary-lg" >
              Close
            </button>
          </router-link>
        </div>
      </template>
    </popup-detail>
  </div>
</template>

<script>
  import {get,post} from '@/services/index.js'
  import {mapGetters} from 'vuex';
  import UserPreference from '@/components/hotel/concierge/checkin/Preference'
  
  export default {
    components:{
      UserPreference
    },
    data(){
      return{
        is_load: true,
        error: '',
        error_push: '',
        data: [],
        reservation: {},
        show_message_success: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant'])
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadPreferenceList(),
          this.loadReservationDetail()
        ]).catch(err=>this.error=err).finally(()=>this.is_load=false)
      },
      loadReservationDetail(){
				return new Promise((success,fail)=>{
					get("CONCIERGE",`reservation/${this.$route.params.reservation_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							this.reservation = response.data.data
							let not_allowed_status = ['CHECKOUT','CANCELLED']
							let status_not_valid = not_allowed_status.some(x=>x==response.data.data.status)
							if(status_not_valid){
                fail("Invalid Reservation. Please contact the staff for further information")
							}else{
								success()
							}
						}else{
							fail(response.data.message)
						}
					})
				})
			},
      loadPreferenceList(){
        return new Promise((success,fail)=>{
          get('CORE_HOTEL',`merchant/${this.getMerchant.id}/guest-profile-preference`).then(response=>{
            let res = response.data
            if(res.success){
              this.data = res.data
              this.data = this.data.map((y,i_y)=>{
                y.question_list = y.question_list.map((x,index)=>{
                  let return_data = {
                    ...x,
                    answer: null,
                    error: ''
                  }
                  if(x.guest_profile_preference_question.type != 'TEXT' && x.use_other){
                    x.preference_list.push({
                      id:`other_${index}`,
                      name: 'Other',
                      answer: ''
                    })
                  }
                  if(x.guest_profile_preference_question.type == 'TEXT'){
                    return_data.answer = ''
                  }else if(x.guest_profile_preference_question.type == 'CHOICE'){
                    return_data.answer = {}
                  }else if(x.guest_profile_preference_question.type == 'MULTIPLE_CHOICE'){
                    return_data.answer = []
                  }
                  return return_data
                })
                return y
              })
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      savePreferenceAnswer(data){
        if(data.is_other){
          this.data[data.index_category].question_list[data.index].preference_list[this.data[data.index].preference_list.length-1].answer = data.answer
        }else{
          this.data[data.index_category].question_list[data.index].answer = data.answer
        }
      },
      submitForm(){
        return new Promise((success,fail)=>{
          this.error_push = ''
          let params = {
            guest_id: this.reservation.guest_profile != null ? this.reservation.guest_profile.id : this.reservation.booked_by.id ,
            guest_preference: []
          }
          this.data.forEach((item_category,index_category)=>{
            item_category.question_list.forEach((item,index)=>{
              let params_preference = {
                preference: null,
                preference_other: null,
                preference_question: item.id
              }
              let other_option_id = `other_${index}`
              if(item.guest_profile_preference_question.type == 'TEXT'){
                if(item.answer != ''){
                  params_preference.preference_other = item.answer
                  params.guest_preference.push(params_preference)
                }
              }else if(item.guest_profile_preference_question.type == 'CHOICE'){ 
                if(item.answer.id){
                  if(item.answer.id == other_option_id){
                    params_preference.preference_other = item.answer.answer
                  }else{
                    params_preference.preference = item.answer.id
                  }
                  params.guest_preference.push(params_preference)
                }
              }else{
                item.answer.forEach((ans_item,i)=>{
                  params_preference.preference_other = null
                  params_preference.preference = null
                  if(ans_item.id == other_option_id){
                    params_preference.preference_other = ans_item.answer
                  }else{
                    params_preference.preference = ans_item.id
                  }
                  let params_preference_clone = this.$deepCopy(params_preference)
                  params.guest_preference.push(params_preference_clone)
                })
              }
            })
          })
          if(params.guest_preference.length == 0){
            this.error_push = 'Please at least answer on of the question'
            fail()
          }else{
            let fd = new FormData()
            fd.append("form_data",JSON.stringify(params))
            post("CONCIERGE",`save-reference?merchant_id=${this.getMerchant.id}`,fd).then(response=>{
              let res = response.data
              if(res.success){
                this.show_message_success = true
                success()
              }else{
                fail(res.message)
              }
            })
          }
        })
      },
      toggleSuccessMessage(){
        this.show_message_success = !this.show_message_success
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/PreferenceForm.vue